import _isNil from 'lodash/isNil';
import { EngagedCandidate } from '../../firebase/firestore/documents/candidate';
import { Collections } from '../../firebase/firestore/collections';
import { useDocumentSnapshotWithLoading } from '../../firebase/firestore/hooks';

export type UseCandidateWithLoadingResult = {
  candidate?: EngagedCandidate | undefined;
  loading: boolean;
};

const useCandidate = (candidateId: string | undefined): UseCandidateWithLoadingResult => {
  const result = useDocumentSnapshotWithLoading<EngagedCandidate>(Collections.CANDIDATES, candidateId);
  const { data: candidateData, loading } = result ?? { data: undefined, loading: false };

  return { candidate: _isNil(candidateData) ? undefined : candidateData, loading };
};

// eslint-disable-next-line import/no-default-export
export default useCandidate;
